//import 'bootstrap/scss/bootstrap.scss'
// import 'bootstrap/dist/js/bootstrap'
// import 'bootstrap/scss/bootstrap.scss'
// import * as bootstrap from 'bootstrap'

import './custom.sass';
import { mount } from 'svelte';

import HeaderTop from './mock_blocks/HeaderTop.svelte';
import './hiddenScrolled';
import TopMenu from './mock_blocks/TopMenu.svelte';
import ModalMenu from './ModalMenu.svelte';
import FeedBackForm from './FeedBackForm.svelte';
import FeedBackPhone from './FeedBackPhone.svelte';

import Accordion from 'accordion-js';
import 'accordion-js/dist/accordion.min.css';

console.log('app', document.querySelector('#landing-header-top'));

// const headerTopApp = mount(HeaderTop, {
// 	target: document.querySelector('#landing-header-top') as HTMLElement,
// 	props: {}
// });

const burgerApp = mount(ModalMenu, {
	target: document.querySelector('.landing-header__right > div:first-child') as HTMLElement,
	props: {}
});

// console.log('topMenuApp', document.querySelector('.landing-header__right > div:first-child'));
// const topMenuApp = mount(TopMenu, {
// 	target: document.querySelector('.landing-header__right > div:first-child') as HTMLElement,
// 	props: {}
// });

const feedbackForm = mount(FeedBackForm, {
	target: document.querySelector('body'),
	anchor: document.querySelector('footer'),
	props: {}
});

const feedBackPhone = mount(FeedBackPhone, {
	target: document.querySelector('#feedback-phone-app-container') as HTMLElement,
	props: {}
});

window.addEventListener('DOMContentLoaded', () => {
	// @ts-ignore
	const accordions = Array.from(document.querySelectorAll('.accordion-container'));
	new Accordion(accordions, {});
});
